export const vaultTypeToLabel = {
  VaultDeposit: 'Deposit',
  VaultRedeem: 'Withdraw',
}
